import type { Prompt } from '../../types'
import { resolveReviewModeFromPrompt } from '../../types/review-mode'
import type { PromptDto } from './dtos/prompt'

export function mapPrompt(dto: PromptDto): Prompt {
  return {
    promptId: dto.prompt_id,
    title: dto.title,
    description: dto.description,
    category: dto.category ?? undefined,
    userPrompt: dto.user_prompt,
    systemPrompt: dto.system_prompt ?? undefined,
    llmModel: dto.llm_model,
    promptType: dto.prompt_type,
    isFavorite: dto.is_favorited ?? false,
    reviewMode: resolveReviewModeFromPrompt(dto),
    requiresDocumentComments: dto.requires_document_comments ?? false,
    requiresFullDocument: dto.requires_full_document ?? false,
  }
}
